import { FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState } from "../../../../toolkit/uicomponent";
import { AlertType } from "../../../../toolkit/alert/alerttype";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentCSSStyle } from "../../../../toolkit/uicomponentcss";
import { UIComponentView } from "../../../../toolkit/uicomponentview";
import { CreateFlashMessageViewImpl } from "./createflashmessageview";
import { CreateFlashMessageCSSStyleImpl } from "./createflashmessagecss";
import { CreateFlashMessageAPIModel, CreateFlashMessageAPIModelImpl } from "./createflashmessageapimodel";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { APIFeatures } from "src/com/sixdee/crbtportal/core/util/apifeatures";
import { APIModelHandler, APIModel } from "../../../../toolkit/uicomponentapimodel";

export interface CreateFlashMessageComponentProps extends UIComponentProps
{
    headerTitle:string;
    isMessageEditable:boolean;
    flashMessageDto: FlashMessageDto;
    closePopup(): void;
    showSetFlash(flashMessageDto: FlashMessageDto): void;
    showSubscriptionDetails(flashMessageDto: FlashMessageDto): void;
    showPopup(id:string,msg:string,type:AlertType):void;
}

export interface CreateFlashMessageComponentState extends  UIComponentState
{
   isMessageEditable:boolean;
   showConfirmation: boolean;
}

export interface CreateFlashMessageComponentHandler extends UIComponentHandler
{
    onCancelClick():void;
    onNextClick(statusMsg:string): void;
    toggleConfirmPopup(showConfirmation: boolean): void;
}

export class CreateFlashMessageComponent extends UIComponentImpl<CreateFlashMessageComponentProps, CreateFlashMessageComponentState, FlashMessageDto> 
implements CreateFlashMessageComponentHandler
{
    constructor(props: CreateFlashMessageComponentProps, state:CreateFlashMessageComponentState)
    {
        super(props);
        this.state = {showConfirmation: false,isMessageEditable:props.isMessageEditable};
    }
   
    componentDidMount()
    {
        // if(this.getContext().getUserContext().getIsLoggedIn())
        // {
        //     (this.getView() as BuyToneViewImpl).showLoader();   
        //     (this.getAPIModel() as BuyToneAPIModel).getTonePrice(this.props.toneDto);
        // }
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<FlashMessageDto>
    {
        return new CreateFlashMessageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new CreateFlashMessageCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new CreateFlashMessageAPIModelImpl(applicationContext, apiModelHandler);
    }

    onCancelClick(): void {
        this.props.closePopup();
    }
   
    toggleConfirmPopup(showConfirmation: boolean): void
    {
        if(showConfirmation)
        {
            (this.getView() as CreateFlashMessageViewImpl).showLoader();   
            (this.getAPIModel() as CreateFlashMessageAPIModel).getSubscriberDetails(this.props.flashMessageDto);
        }
        else
        {
          this.setState({showConfirmation: false});
        }
    }
    onNextClick(statusMsg:string)
    {
        // let flashDto = new FlashMessageDtoImpl();
        // flashDto.setId(this.state.isMessageEditable ? this.props.flashMessageDto.getId() : "");
        // flashDto.setPlanName(this.state.isMessageEditable ? this.props.flashMessageDto.getPlanName(): "");
        this.props.flashMessageDto.setStatusMessage(statusMsg);
        // flashDto.setMsisdn(this.state.isMessageEditable ? this.props.context.getUserContext().getMsisdn() : "");
        this.props.showSetFlash(this.props.flashMessageDto);
        // if(!this.props.context.getUserContext().getIsLoggedIn())
        // {
        //     this.props.showSetFlash(this.props.flashMessageDto);
        // }
        // else
        // {
        //     //setstate for confirmation and call pai after confirming yes
        //     this.setState({showConfirmation: true});
        // }   
    }

    
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.GET_FLASH_SUBSCRIPTION)
        {
            if(data.existingUser)
            {
                (this.getAPIModel() as CreateFlashMessageAPIModel).setFlashMessage(this.props.flashMessageDto);
            }
            else
            {
                (this.getView() as CreateFlashMessageViewImpl).dismissLoader();  
                this.props.showSubscriptionDetails(this.props.flashMessageDto);
            }
        }
        else if(feature === APIFeatures.SET_FLASH_MESSAGE)
        {
            (this.getView() as CreateFlashMessageViewImpl).dismissLoader();  
            this.props.showPopup("Create/Edit Note4U", this.getContext().getResources().getString(
                Strings.your_order_is_successfully_completed),
            AlertType.SUCCESS);
        }
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as CreateFlashMessageViewImpl).dismissLoader();
        this.props.showPopup("Create/Edit Note4U",description,AlertType.ERROR);     
    }
    // onSuccess(feature: APIFeatures, description: string, data: any): void 
    // {
    //     if(feature === APIFeatures.GET_TONE_PRICE)
    //     {
    //         (this.getView() as BuyToneViewImpl).dismissLoader();  
    //         let packDetails = this.props.context.getConfigurationSettings().getPropertyBasedOnLanguage("VALIDITY");
            
    //         console.log("packdetails: " + packDetails);
      
        
    //         let PRICE_TEXT: string = new GetPackDetails(packDetails)
    //         .getPrice((data as GetTonePriceDetailsDto).getPackName(),
    //         (data as GetTonePriceDetailsDto).getPrice());
             
            
    //          console.log("-----tigerPRICE_TEXT: " + PRICE_TEXT +", packName: " + (data as GetTonePriceDetailsDto).getPackName());
    //          this.setState({price:PRICE_TEXT, msisdn: description, isPrice: true, packName: (data as GetTonePriceDetailsDto).getPackName()});
    //          this.setState({isNewUser:(data as GetTonePriceDetailsDto).getIsNewUser()});
    //          console.log("get tone price on buy now:",this.state.packName);
    //     }
    //     else if(feature === APIFeatures.BUY_TONE)
    //     {
    //         console.log("------buy");
    //         console.log("------"+this.state.packName);
    //         (this.getView() as BuyToneViewImpl).dismissLoader();  
    //         this.props.context.getUserContext().setPackName(this.state.packName);
    //         this.props.context.setUserContext(this.props.context.getUserContext());
    //         this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);   

    //     }
    //    else  if(feature === APIFeatures.GENERATE_OTP)
    //     {
    //         (this.getView() as BuyToneViewImpl).dismissLoader();  
    //         this.props.context.getUserContext().setMsisdnB(this.state.msisdn);
    //         (this.props.context.getUserContext().setSecToken(""));
    //         this.props.context.getUserContext().setPackName(this.state.packName);
    //         this.props.context.getUserContext().setIsnewUser(this.state.isNewUser);
    //         this.props.context.setUserContext(this.props.context.getUserContext());

    //         if(this.state.isPackUpgradeSelected)
    //         { 
    //             //login route after confirm for non-logged in user

    //             this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_now) + "_" +
    //             this.props.context.getResources().getString(Strings.upgradePack) + "_" + 
    //             this.props.context.getResources().getString(Strings.otp_verification));
    //             console.log("upgrade pack redirection :Buy Now");

    //         }
    //         else
    //         {
    //             this.props.showPopupOption(this.getContext().getResources().getString(Strings.buy_now) + "_" +
    //             this.props.context.getResources().getString(Strings.otp_verification));
    //         }
    //     }
    //     else
    //     {
    //         (this.getView() as BuyToneViewImpl).dismissLoader();    
    //     }
    // }
    
    // onFailure(feature: APIFeatures, description: string, data: any): void 
    // {
    //     (this.getView() as SetFlashMessageViewImpl).dismissLoader();  
    //     if(feature === APIFeatures.BUY_TONE)
    //     {
    //         this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   

    //     }
    //     else
    //     {
    //         this.props.showPopup(this.getContext().getResources().getString(Strings.buy_now),description,AlertType.ERROR);   

    //     }
    // }            
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/createflashmessage/createflashmessagecomponent.tsx